// @ts-nocheck







import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest } from './index';

export const convertDataToServer = (
gpmMaintenanceCalculation) => (
{
  ...gpmMaintenanceCalculation,
  sum: convertFromRubToKop(gpmMaintenanceCalculation.sum),
  months: gpmMaintenanceCalculation.months.map(
    convertDataToServerGpmMaintenanceCalculationMonth
  )
});

export const convertDataFromServer = (
gpmMaintenanceCalculation) => (
{
  ...gpmMaintenanceCalculation,
  sum: convertFromKopToRub(gpmMaintenanceCalculation.sum),
  months: gpmMaintenanceCalculation.months.map(
    convertDataFromServerGpmMaintenanceCalculationMonth
  )
});

export const convertDataToServerGpmMaintenanceCalculationMonth = (
gpmMaintenanceCalculationMonth) => (
{
  ...gpmMaintenanceCalculationMonth,
  maintenanceCost: convertFromRubToKop(
    gpmMaintenanceCalculationMonth.maintenanceCost
  ),
  expertiseCost: convertFromRubToKop(
    gpmMaintenanceCalculationMonth.expertiseCost
  ),
  cost: convertFromRubToKop(gpmMaintenanceCalculationMonth.cost)
});

export const convertDataFromServerGpmMaintenanceCalculationMonth = (
gpmMaintenanceCalculationMonth) => (
{
  ...gpmMaintenanceCalculationMonth,
  maintenanceCost: convertFromKopToRub(
    gpmMaintenanceCalculationMonth.maintenanceCost
  ),
  expertiseCost: convertFromKopToRub(
    gpmMaintenanceCalculationMonth.expertiseCost
  ),
  cost: convertFromKopToRub(gpmMaintenanceCalculationMonth.cost)
});

const basedUrl = 'gpmMaintenanceCalculation';
const gpmMaintenanceCalculation = new CommonApi(
  basedUrl,
  'расчет стоимости экспертизы ТО и ГПМ',
  convertDataToServer,
  convertDataFromServer
);

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус расчет`);
};

const print = async (vehiclePlanId, filter) => {
  const printed = await downloadRequestWithToken(`/${basedUrl}/print`, {
    ...filter,
    vehiclePlanId
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export default {
  ...gpmMaintenanceCalculation,
  calculate,
  changeStatus,
  print
};
